import { render, staticRenderFns } from "./DespesaParceiroForm.vue?vue&type=template&id=1453fd20"
import script from "./DespesaParceiroForm.vue?vue&type=script&lang=js"
export * from "./DespesaParceiroForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports